export const INCREMENT = 'INCREMENT';

export const DECREMENT = 'DECREMENT';

export const ADD = 'ADD';
export const DELET ='DELET';
export const HIDE = 'HIDE';
export const SHOW = 'SHOW';
export const ADD_A ='ADD_A';
// export const SUMBIT ='SUMBIT';
export const XZXM ='XZXM';
export const XZKM ='XZKM';
export const GOTOAPPROVAL = 'GOTOAPPROVAL';
export const GOTOMOVEBX = 'GOTOMOVEBX';
export const selectProj = 'selectProj';
export const SET_FORM_AUTHS = 'setFormAuths'



// WEBPACK FOOTER //
// ./src/store/types.js